<template>
  <div class="text-center">
    <v-dialog persistent v-model="openCreateForm" width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2">Create Mobile Version</v-card-title>

        <v-card-text>
          <div>
            <v-form
              ref="createForm"
              v-model="valid"
              lazy-validation
              class="input-container small-table-padding"
            >
              <v-select
                :rules="platformRules"
                name="platform"
                id="platform"
                v-model="formData.platform"
                :items="versionPlatforms"
                label="Select Platform"
                required
              ></v-select>

              <input
                v-model="formData.version"
                type="number"
                :rules="versionRules"
                placeholder="Enter Version"
                name="version"
                id="version"
                class="form-control mt-4 mb-5"
                required
              />

              <textarea
              rows="6"
                v-model="formData.description"
                placeholder="Enter Description"
                name="description"
                id="description"
                class="form-control mt-4 mb-5"
                :rules="descriptionRules"
              ></textarea>
              <v-checkbox v-model="formData.isForced" class="checkBox-stye" :label="`Is Forced`"></v-checkbox>

              <div class="text-right mt-5">
                <v-btn :disabled="!valid" color="success" class="mr-4" @click="submitForm()">Submit</v-btn>
                <v-btn color="error" class="mr-4" @click="closeModal()">Cancel</v-btn>
              </div>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from "@/config.js";
export default {
  props: ["openCreateForm"],
  data() {
    return {
      showLoader: false,
      valid: true,
      platformRules: [v => !!v || "Platform is required"],
      versionRules: [
        v => /^[^-\s][a-zA-Z0-9_\s-]*$/g.test(v) || "Version is required"
      ],
      descriptionRules: [
        v => /^[^-\s][a-zA-Z0-9.\s-]*$/g.test(v) || "Description is required"
      ],
      versionPlatforms: ["ANDROID", "IOS"],
      formData: {
        platform: "",
        version: "",
        description: "",
        isForced: false
      }
    };
  },

  methods: {
    // close modal event
    closeModal() {
      this.$emit("close");
    },

    // submit event for edit and create functionality
    submitForm() {
      if (this.$refs.createForm.validate()) {
        let obj = {
          platform: this.formData.platform,
          version: this.formData.version,
          description: this.formData.description,
          is_forced: this.formData.isForced
        };
        let url = `${config.BASE_URL}api/v2/admin/mobile-versions`;
        this.$http.post(url, obj).then(response => {
          if (response.body.status) {
            this.showLoader = false;
            this.$refs.createForm.reset();
            this.$emit("close");
            this.$emit("getMobileVersionsApiCall");
          } else {
            this.showLoader = false;
          }
        });
      }
    }
  },

  watch: {}
};
</script>
<style lang="scss">
.checkBox-stye {
  .v-input__control {
    .v-input__slot {
      .v-label {
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>
